import Box from "@mui/material/Box";
import backgroundImageDesktop from "../../../assets/images/how-it-works-img.webp";
import backgroundMobileImage from "../../../assets/images/background-mobile-image.webp";
import useUserStore from "../../../store/useUserStore";
import { useRef, useEffect } from "react";
import { useImageHeightStore } from "../../../store/useImagesHeight";

export default function HowWeWorkBlock({ scrollToRef }) {
  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);
  const setImageHeight = useImageHeightStore((state) => state.setImageHeight);

  const isMobile = windowInnerWidth < 640;

  const test = useRef(null);
  const test2 = useRef(null);

  useEffect(() => {
    if (test2.current) {
      const blockHeight = test2.current.offsetHeight;
    }
  }, []);

  return (
    <Box
      ref={scrollToRef}
      sx={{
        width: "100%",
        height: "100%",
        px: isMobile ? "16px" : "80px",
        display: "flex",
        backgroundImage: isMobile ? `url(${backgroundMobileImage})` : "none",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        justifyContent: "center",
      }}
    >
      {!isMobile ? (
        <Box
          ref={test}
          component={"img"}
          src={backgroundImageDesktop}
          onLoad={(e) => {
            const height = e.target.clientHeight;
            setImageHeight("how-we-work", height);
          }}
          alt="background image"
          sx={{
            width: "calc(100% + 160px)",
            maxWidth: "1280px",
            height: "auto",
          }}
        />
      ) : (
        <Box
          ref={test}
          component={"img"}
          src={backgroundMobileImage}
          onLoad={(e) => {
            const height = e.target.clientHeight;
            setImageHeight("how-we-work-mobile", height);
          }}
          alt="background image"
          sx={{
            width: "calc(100% + 160px)",
            maxWidth: "1280px",
            height: "auto",
          }}
        />
      )}
    </Box>
  );
}
